import type { SvgProps } from "@/utils/svg-wrapper";

import React, { useId } from "react";

import { Svg } from "@/utils/svg-wrapper";

export const KeyboardDelIcon: React.FC<SvgProps> = ({ className }) => {
  const id = useId();

  return (
    <Svg className={className} height="28" viewBox="0 0 29 28" width="29">
      <g clipPath={`url(#${id})`}>
        <path
          clipRule="evenodd"
          d="M10.035 6.5H21.5001C22.8808 6.5 24.0001 7.61929 24.0001 9V19C24.0001 20.3807 22.8808 21.5 21.5001 21.5H10.035C9.41743 21.5 8.82169 21.2714 8.36262 20.8582L2.80707 15.8582C1.70362 14.8651 1.70362 13.1349 2.80707 12.1418L8.36262 7.14177C8.82168 6.72861 9.41743 6.5 10.035 6.5ZM7.35918 6.02682C8.09367 5.36578 9.04687 5 10.035 5H21.5001C23.7092 5 25.5001 6.79086 25.5001 9V19C25.5001 21.2091 23.7092 23 21.5001 23H10.035C9.04687 23 8.09368 22.6342 7.35918 21.9732L1.80362 16.9732C0.0381026 15.3842 0.0381 12.6158 1.80362 11.0268L7.35918 6.02682ZM13.0304 10.4697C12.7375 10.1768 12.2627 10.1768 11.9698 10.4697C11.6769 10.7626 11.6769 11.2374 11.9698 11.5303L14.4394 14L11.9698 16.4697C11.6769 16.7626 11.6769 17.2374 11.9698 17.5303C12.2627 17.8232 12.7375 17.8232 13.0304 17.5303L15.5001 15.0607L17.9698 17.5303C18.2627 17.8232 18.7375 17.8232 19.0304 17.5303C19.3233 17.2374 19.3233 16.7626 19.0304 16.4697L16.5608 14L19.0304 11.5303C19.3233 11.2374 19.3233 10.7626 19.0304 10.4697C18.7375 10.1768 18.2627 10.1768 17.9698 10.4697L15.5001 12.9393L13.0304 10.4697Z"
          fill="inherit"
          fillRule="evenodd"
        />
      </g>
      <defs>
        <clipPath id={id}>
          <rect fill="white" height="28" transform="translate(0.5)" width="28" />
        </clipPath>
      </defs>
    </Svg>
  );
};
